import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import {VendPackageLineItemEditComponent} from '../../components/Editors/VendPackageLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-vendpackagelineitem-grid',
  templateUrl: './VendPackageLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => VendPackageLineItemGridComponent)}]
})
export class VendPackageLineItemGridComponent extends BaseGridComponent {
    public lineItems: ent.VendPackageLineItem[] = [];
    selectedLineItems: ent.VendPackageLineItem[] = [];
    editedLineItem: ent.VendPackageLineItem;

    @ViewChild(VendPackageLineItemEditComponent) public vendPackageLineItemEdit: VendPackageLineItemEditComponent;
    
    vendPackages: ent.VendPackage[] = [];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.editedLineItem = new ent.VendPackageLineItem();
        this.load();
    }

    public load(){
      
        var filter: filters.VendPackageFilter = {};
        this.domainDataService.getVendPackages(filter).subscribe(x=> this.onGetVendPackagesDone(x));
    }
    
    onGetVendPackagesDone(items: ent.VendPackage[]){
        items.forEach(y=> this.vendPackages.push(y));
    }

    onAddClick(event: any){
      
        this.editedLineItem = new ent.VendPackageLineItem();
        this.vendPackageLineItemEdit.vendPackageDropdown.value = Constants._NONE;
        this.vendPackageLineItemEdit.displayDialog = true;

    }

    onDeleteClick(event: any, lineItem: ent.VendPackageLineItem){
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
    }

    onEditClick(event: any, lineItem: ent.VendPackageLineItem){
        
        this.editedLineItem = lineItem;
        this.vendPackageLineItemEdit.lineItem = lineItem;
        this.vendPackageLineItemEdit.vendPackageDropdown.value = lineItem.VendPackageID;
        this.vendPackageLineItemEdit.displayDialog = true;
    }

    onVendPackageLineItemEditOK(){
        
        var vendPackage = this.vendPackages.filter(x=>x.ID == this.vendPackageLineItemEdit.lineItem.VendPackageID)[0];
        this.editedLineItem.VendPackage = {ID: vendPackage.ID, Name: vendPackage.Name, Inactive: vendPackage.Inactive};
        this.editedLineItem.VendPackageID = vendPackage.ID;

        var newLineItem = _.cloneDeep(this.editedLineItem);
        this.lineItems = <ent.VendPackageLineItem[]>this.addLineItem(newLineItem, this.lineItems);
    }

}